import { Component, Output, Input, EventEmitter } from '@angular/core';
import { GlobalVariables } from '../../variables/global';
import { NavController, ViewController } from 'ionic-angular';
import { camelCase } from 'lodash';

@Component({
  selector: 'dev-jumbotron',
  templateUrl: 'dev-jumbotron.html'
})
export class DevJumbotronComponent {
  public activePageComponent: ViewController;
  public pagesInfo = GlobalVariables.pages;
  @Input() parent: string;
  @Input() props;
  @Output() backEvent = new EventEmitter();
  @Output() nextEvent = new EventEmitter();

  constructor(public nav: NavController) {

  }
  ngOnInit() {
    this.activePageComponent = this.nav.getActive();
  }

  get activePage() {
    return this.pagesInfo[camelCase(this.activePageID)];
  }

  get activePageID() {
    const activePageID: string = this.activePageComponent.id;
    const treeURL = activePageID.split('/');

    return treeURL[treeURL.length - 1];
  }

  get currentIndex() {
    const linkChilds = this.pagesInfo[this.parent].childs;
    const currentIndex: number = linkChilds.indexOf(this.activePageID);
    return currentIndex;
  }

  get linkChilds() {
    return this.pagesInfo[this.parent].childs;
  }

  get childIsFirst() {
    return (this.currentIndex === 0)
  }

  get childIsLast() {
    return (this.currentIndex === this.linkChilds.length - 1);
  }

  get isChild() {
    return window.location.hash.includes('/');
  }

  get sectionTitle() {
    const title = this.pagesInfo[camelCase(this.activePageID)].text
    return (title) ? title : ''
  }

  get title() {
    return (this.parent) ? this.pagesInfo[camelCase(this.parent)].text : this.activePage.text;
  }

  back() {
    const backLink = this.linkChilds[this.currentIndex - 1]

    return this.goTo(backLink);
  }

  goTo(link: string) {
    this.nav.push(link);
  }

  next() {
    const nextLink = this.linkChilds[this.currentIndex + 1]

    return this.goTo(nextLink);
  }
}



// WEBPACK FOOTER //
// ./src/components/dev-jumbotron/dev-jumbotron.ts